import EmailCampaignsIconSvg from '../../../../img/logos/emailCampaigns.svg';
import { createSVGComponentFromSVG } from './create-svg-components-from-svg';

export const EmailCampaignsIcon = createSVGComponentFromSVG(
    EmailCampaignsIconSvg,
    'EmailCampaignsIcon',
);
